import {
  APP_INITIALIZER,
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import en from '@angular/common/locales/en';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, registerLocaleData } from '@angular/common';
import { CalAngularModule } from '@cvx/cal-angular';
import {
  BrowserAnimationsModule,
  provideAnimations,
} from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NextPage } from '@cvx/nextpage';
import { AppConfig } from './core/service/app-config.service';
import { NzZorroModule } from './core/service/nz-zorro.module';
import { NzTableModule } from 'ng-zorro-antd/table';
import { HeaderComponent } from './components/header/header.component';
import { DataService } from './core/service/data_service';
import { ViewerHomeComponent } from './components/viewer-home/viewer-home.component';
import { ReportsMenuComponent } from './components/report-and-info/reports-menu/reports-menu.component';
import { TimesheetReportsComponent } from './components/report-and-info/timesheet-reports/timesheet-reports.component';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { ReportsService } from './core/service/reports.service';
import { HttpUtilityService } from './core/service/http-utility.service';
import { HttpConfigInterceptor } from './auth/interceptors/httpconfig.interceptor';
import { CalService } from './auth/cal.service';
import { WeeklyScheduleDrillComponent } from './components/schedules-and-labor/weekly-schedule-drill/weekly-schedule-drill.component';
import { MaintScheduleJobsComponent } from './components/schedules-and-labor/maint-schedule-jobs/maint-schedule-jobs.component';
import { MaintScheduleJobsService } from './core/service/maint-schedule-jobs.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WeeklyScheduleMxComponent } from './components/schedules-and-labor/weekly-schedule-mx/weekly-schedule-mx.component';
import { RoundPipe } from './core/pipes/round.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { DatePipe } from '@angular/common';
import { VarianceReportComponent } from './components/report-and-info/variance-report/variance-report.component';
import { TrackReportsComponent } from './components/report-and-info/track-reports/track-reports.component';
import { TrackMxSummaryComponent } from './components/report-and-info/reports/track-mx-summary/track-mx-summary.component';
import { TrackMxVareqComponent } from './components/report-and-info/reports/track-mx-vareq/track-mx-vareq.component';
import { TrackMxVarComponent } from './components/report-and-info/reports/track-mx-var/track-mx-var.component';
import { TrackMxVareqVarianceComponent } from './components/report-and-info/reports/track-mx-vareq-variance/track-mx-vareq-variance.component';
import { TrackMxVarVarianceComponent } from './components/report-and-info/reports/track-mx-var-variance/track-mx-var-variance.component';
import { DecimalRoundPipe } from './core/pipes/decimal-round.pipe';
registerLocaleData(en);

export function initializeApp(appConfig: AppConfig) {
  return (): Promise<any> => {
    return appConfig.load();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ViewerHomeComponent,
    ReportsMenuComponent,
    TimesheetReportsComponent,
    WeeklyScheduleDrillComponent,
    MaintScheduleJobsComponent,
    WeeklyScheduleMxComponent,
    RoundPipe,
    VarianceReportComponent,
    TrackReportsComponent,
    TrackMxSummaryComponent,
    TrackMxVareqComponent,
    TrackMxVarComponent,
    TrackMxVareqVarianceComponent,
    TrackMxVarVarianceComponent,
    DecimalRoundPipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    NzZorroModule,
    NextPage,
    NzTableModule,
    NzListModule,
    NzButtonModule,
    NzModalModule,
    MatProgressSpinnerModule,
    BrowserAnimationsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CalAngularModule.forRoot(environment.calConfig),
    // CalAngularModule.forRoot(`assets/config.json`),
  ],
  providers: [
    AppConfig,
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    DataService,
    DatePipe,
    ReportsService,
    MaintScheduleJobsService,
    HttpUtilityService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    CalService,
    MatDatepickerModule,
    MatNativeDateModule,
    { provide: NZ_I18N, useValue: en_US },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
